"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var Button_vue_1 = require("@/client/components/common/Button.vue");
var Color_1 = require("@/Color");
var CardOrderStorage_1 = require("@/client/utils/CardOrderStorage");
var Card_vue_1 = require("@/client/components/card/Card.vue");
var ActiveCardsSortingOrder_1 = require("@/client/utils/ActiveCardsSortingOrder");
exports.default = vue_1.default.extend({
    name: 'SelectCard',
    props: {
        playerView: {
            type: Object,
        },
        playerinput: {
            type: Object,
        },
        onsave: {
            type: Function,
        },
        showsave: {
            type: Boolean,
            required: false,
            default: false,
        },
        showtitle: {
            type: Boolean,
        },
    },
    data: function () {
        return {
            cards: [],
            warning: undefined,
            owners: new Map(),
        };
    },
    components: {
        Card: Card_vue_1.default,
        Button: Button_vue_1.default,
    },
    watch: {
        cards: function () {
            this.$emit('cardschanged', this.getData());
        },
    },
    methods: {
        cardsSelected: function () {
            if (Array.isArray(this.cards)) {
                return this.cards.length;
            }
            else if (this.cards === false || this.cards === undefined) {
                return 0;
            }
            return 1;
        },
        getOrderedCards: function () {
            var _this = this;
            var _a;
            var cards = [];
            if (this.playerinput.cards !== undefined) {
                if (this.playerinput.selectBlueCardAction) {
                    cards = ActiveCardsSortingOrder_1.sortActiveCards(this.playerinput.cards);
                }
                else {
                    cards = CardOrderStorage_1.CardOrderStorage.getOrdered(CardOrderStorage_1.CardOrderStorage.getCardOrder(this.playerView.id), this.playerinput.cards);
                }
            }
            ;
            if (this.playerinput.showOwner) {
                this.owners.clear();
                (_a = this.playerinput.cards) === null || _a === void 0 ? void 0 : _a.forEach(function (card) {
                    var owner = _this.findOwner(card);
                    if (owner !== undefined)
                        _this.owners.set(card.name, owner);
                });
            }
            return cards;
        },
        hasCardWarning: function () {
            if (Array.isArray(this.cards)) {
                return false;
            }
            else if (typeof this.cards === 'object' && this.cards.warning !== undefined) {
                this.warning = this.cards.warning;
                return true;
            }
            return false;
        },
        isOptionalToManyCards: function () {
            return this.playerinput.maxCardsToSelect !== undefined &&
                this.playerinput.maxCardsToSelect > 1 &&
                this.playerinput.minCardsToSelect === 0;
        },
        getData: function () {
            return Array.isArray(this.$data.cards) ? this.$data.cards.map(function (card) { return card.name; }) : [this.$data.cards.name];
        },
        saveData: function () {
            this.onsave([this.getData()]);
        },
        getCardBoxClass: function (card) {
            if (this.playerinput.showOwner && this.getOwner(card) !== undefined) {
                return 'cardbox cardbox-with-owner-label';
            }
            return 'cardbox';
        },
        findOwner: function (card) {
            for (var _i = 0, _a = this.playerView.players; _i < _a.length; _i++) {
                var player = _a[_i];
                if (player.playedCards.find(function (c) { return c.name === card.name; })) {
                    return { name: player.name, color: player.color };
                }
            }
            return undefined;
        },
        getOwner: function (card) {
            var _a;
            return (_a = this.owners.get(card.name)) !== null && _a !== void 0 ? _a : { name: 'unknown', color: Color_1.Color.NEUTRAL };
        },
        isSelectOnlyOneCard: function () {
            return this.playerinput.maxCardsToSelect === 1 && this.playerinput.minCardsToSelect === 1;
        },
        buttonLabel: function () {
            return this.isSelectOnlyOneCard() ? this.playerinput.buttonLabel : this.playerinput.buttonLabel + ' ' + this.cardsSelected();
        },
    },
});
